module.exports = __webpack_public_path__ + "img/furnace_300.a9129df4.jpg";